"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var AgroSearcher = /** @class */ (function () {
    function AgroSearcher() {
    }
    AgroSearcher.prototype.sourceProjects = function () {
        var _this = this;
        return axios_1.default.get(process.env.VUE_APP_API_URL + process.env.VUE_APP_CATALOG_PROXY_AGRO_SOURCE_P_URL)
            .then(function (response) { return _this.processData(response); });
    };
    AgroSearcher.prototype.destinationProjects = function () {
        var _this = this;
        return axios_1.default.get(process.env.VUE_APP_API_URL + process.env.VUE_APP_CATALOG_PROXY_AGRO_DST_P_URL)
            .then(function (response) { return _this.processData(response); });
    };
    AgroSearcher.prototype.configMap = function () {
        return axios_1.default.get(process.env.VUE_APP_API_URL + process.env.VUE_APP_CATALOG_PROXY_AGRO_CFG_MAP_URL)
            .then(function (response) { return response.data; });
    };
    AgroSearcher.prototype.processData = function (response) {
        return Array.isArray(response.data)
            ? response.data.map(function (batch) {
                return {
                    id: batch.id,
                    article: batch.article,
                    name: batch.name,
                };
            })
            : [];
    };
    return AgroSearcher;
}());
exports.default = AgroSearcher;
//# sourceMappingURL=AgroSearcher.js.map